/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form } from 'semantic-ui-react'
import moment from 'moment'

export default class DateField extends PureComponent {
  onChange = value => {
    const { onChange, type } = this.props
    let returnValue = moment(value)

    if (type === 'endOfDay') {
      returnValue = returnValue.endOf('day').format('x')
    } else {
      returnValue = returnValue.startOf('day').format('x')
    }

    onChange(returnValue)
  }

  render() {
    const { value, onChange, label } = this.props

    const formattedDate = moment(parseInt(value, 10)).format('YYYY-MM-DD')

    return (
      <Form.Field required>
        <label>{label}</label>
        <input
          type="date"
          value={formattedDate}
          onChange={e => onChange(Number(moment(e.target.value).format('x')))}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/dateField.js